import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from '../action-types';

export const receiveLogin = (authToken, user) => ({
  type: LOGIN_SUCCESS,
  authToken,
  user,
});

export const receiveLoginFailure = (message) => ({
  type: LOGIN_FAILURE,
  message,
});

export const receiveLogout = () => {
  return {
    type: LOGOUT,
  };
};
